<template><div><h1>VUX V2.6.3 released</h1>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[feature] support prop:radio-required #2004</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] now on-change params has labels as second param #2018</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[fix] fix method name starts with _ will get vue(2.4.4) warning #2001</li>
<li>[feature] add method:getCurrentIndex</li>
<li>[feature] add slot:button-before slot:button-after</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] add event:on-blur</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] fix no padding when using slot and type === text</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] toast error when clicking error icon #2009</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.3-125.vue?c13b3b66